<template>
  <v-container class="py-0 px-0" fluid>
    <v-row>
      <v-row justify="end" class="pr-3 pb-2" no-gutters>
        <mf-button label="Criar novo produto loja" class="mr-3" data-cy="createProduct" @click="openCreateDialog()" />
      </v-row>
    </v-row>
    <v-card>
      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row class="pt-3">
            <v-col cols="9" class="pt-0 pl-6">
              <span class="table-card-title pl-0">Produtos Loja</span>
            </v-col>
            <v-col cols="3">
              <mf-search v-model="filters.search" placeholder="Busca por EAN, nome ou SKU" hide-details data-cy="productSearchBar" @input="filterBySearch" />
            </v-col>
          </v-row>
        </v-container>
        <v-data-table
          :headers="headers"
          :loading="paginationLoading"
          :server-items-length="maxRecords"
          :items="products"
          :options.sync="options"
          :footer-props="{ itemsPerPageOptions: [15, 50, 100] }"
        >
          <template v-slot:item="{ item }">
            <tr @click="openProductDetail(item)">
              <td>
                <v-img
                  v-if="item.product.images && item.product.images.length && item.product.images[0].url"
                  :src="showMainImage(item.product.images)"
                  contain
                  height="40px"
                  class="td-img"
                />
                <mf-icon v-else color="cinza-0" class="icon-align"> image </mf-icon>
              </td>
              <td>
                {{ item.sku || '-' }}
              </td>
              <td>{{ item.name || '-' }}</td>
              <td>
                {{ item.store.name || '-' }}
              </td>
              <td>
                <div class="d-flex align-center">
                  <mf-icon fill small :color="statusColor(item.active)">fiber_manual_record</mf-icon>
                  <span class="ml-2">{{ item.active ? 'Ativo' : 'Inativo' }}</span>
                </div>
              </td>
              <td class="azul-l40" align="right">
                <mf-tooltip top>
                  <template #activator="{ on }">
                    <mf-button icon="open_in_new" type="icon" color="marca-0-l40" text @click="openProductDetail(item)" />
                  </template>
                  <span>Ver produto</span>
                </mf-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { QUERY_GET_PRODUCT_STORE } from '../../graphql'

export default {
  name: 'ProductList',
  components: {},
  data: () => ({
    timeout: {},
    filterOpen: false,
    categoriesModal: false,
    filters: {
      search: '',
      category: 'Todos',
      categories: [],
      image: 'Todos',
      active: 'Todos',
    },
    options: {},
    dialogSingleProduct: false,
    products: [],
    selectedProduct: {},
    isNewProduct: false,
    maxRecords: 1,
    paginationLoading: false,
    categories: [],
    filtersQuantity: 0,
    categoriesFilter: [],
    values: [],
    currentIndex: 0,
    hasNotDepartment: false,
    hasNotCategory: false,
  }),
  computed: {
    headers() {
      let headers = [
        {
          text: 'Imagem',
          value: 'images',
          width: '5%',
          sortable: false,
        },
        {
          text: 'Código interno',
          value: 'manuallyEdited',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome em exibição',
          value: 'name',
          width: '40%',
          sortable: false,
        },
        {
          text: 'Loja',
          value: 'active',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'active',
          width: '10%',
          sortable: false,
        },
        {
          text: '',
          value: '',
          width: '20%',
          sortable: false,
          align: 'right',
        },
      ]

      return headers
    },
  },
  watch: {
    options(value) {
      this.getData()
    },
    filters: {
      handler(filters) {
        this.filtersQuantity = 0
        if (filters.category !== 'Todos') {
          this.filtersQuantity++
        }

        if (filters.categories !== []) {
          this.filtersQuantity++
        }

        if (filters.active !== 'Todos') {
          this.filtersQuantity++
        }

        if (filters.image !== 'Todos') {
          this.filtersQuantity++
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    applyFilters() {
      this.getData()
      this.filterOpen = false
    },
    openCategories() {
      this.categoriesModal = true
    },
    clearFilters() {
      this.filters.category = 'Todos'
      this.filters.categories = []
      this.filters.active = 'Todos'
      this.filters.image = 'Todos'
      this.filtersQuantity = 0
      this.getData()
    },
    openCreateDialog() {
      this.$router.push({ path: '/produtos/novo-produto-loja' })
    },
    openEditDialog(product) {
      this.selectedProduct = product
      this.isNewProduct = false
      this.dialogSingleProduct = true
    },
    filterBySearch(query) {
      clearTimeout(this.timeout)
      this.paginationLoading = true
      this.timeout = setTimeout(() => {
        this.options.page = 1
        this.getData()
      }, 1000)
    },
    async getData() {
      try {
        this.paginationLoading = true
        const {
          data: {
            storeProducts: { storeProducts, records },
          },
        } = await this.$apollo.query({
          query: QUERY_GET_PRODUCT_STORE,
          variables: {
            page: this.options.page || 1,
            pageSize: this.options.itemsPerPage || 15,
            search: this.filters.search,
          },
          context: {
            uri: this.$microservicesUrls['fedGateway'],
          },
          fetchPolicy: 'no-cache',
        })
        this.products = storeProducts
        this.maxRecords = records
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar produtos', snackbarColor: 'error' })
      } finally {
        this.paginationLoading = false
      }
    },
    openProductDetail(item) {
      const { id } = item
      this.$router.push({ path: `/produtos/alterar-produto-loja/${id}` })
    },
    showMainEan(eans) {
      const mainEan = eans.find((ean) => ean.isMain)

      if (mainEan) return mainEan.ean

      return ''
    },
    showMainImage(images) {
      return images[0].urlMiniature.length ? images[0].urlMiniature : images[0].url
    },
    statusColor(status) {
      return status ? '#03e36a' : '#F15435'
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 14px;
  font-weight: bold;
}

::v-deep tbody {
  td {
    color: $cinza-0;
    font-size: 14px;
    line-height: 1;
  }
  td:hover {
    cursor: pointer;
  }
}

.td-img {
  width: 40px;
  height: 40px;
}
.icon-align {
  padding-left: 8.5px;
}
.icon-color {
  color: $marca-0-l40 !important;
  text-decoration: none !important;
}
.chip-color-catalog {
  background-color: #ccf0d8 !important;
  color: $verde-d20;
}
.chip-color-edit {
  background-color: #f8e2d2 !important;
  color: #86410f;
}
</style>
